import { Component, Prop } from 'vue-property-decorator';
import { FieldInfoModel } from '~/app/core/apiClient/api';
import { Headline } from '~/components/atoms';
import { Align } from '~/components/atoms/headline/Headline';
import Icon from '~/components/atoms/icons/Icon';
import { Colors } from '~/utils/theme/colors';
import { VueComponent } from '~/utils/vue-component';

interface GolfCourseDataProps {
  courseId: string;
}

const rootClass = 'czt-golf-course-data';

@Component
export default class GolfCourseData extends VueComponent<GolfCourseDataProps>
  implements GolfCourseDataProps {
  @Prop({ required: true })
  public courseId!: string;

  protected data: FieldInfoModel | null = null;

  public mounted() {
    const fieldId = Number(this.courseId);
    if (Number.isNaN(fieldId)) {
      return;
    }
    this.$api
      .golf()
      .golfWrapperGetFieldInfo(fieldId)
      .then((res) => {
        this.data = res;
      });
  }

  public render() {
    const classes = [rootClass, 'mb-3'];
    if (!this.data) {
      return;
    }
    return (
      <div class={classes.join(' ')}>
        <Headline align={Align.LEFT} underscore level={4} class='mb-5'>
          {this.$t('app.golf.title')}
        </Headline>
        {Object.entries(this.data).map(([key, value]) => {
          if (key === 'fieldName' || !this.$te(`app.golf.${key}`)) {
            return;
          }
          return (
            <div class='d-flex align-center'>
              <span class='flex-grow-1 text-h6'>
                {this.$t(`app.golf.${key}`)}
              </span>
              <span
                class='pl-1'
                style={{
                  fontSize: typeof value === 'boolean' ? '1.5rem' : '1.25rem',
                }}
              >
                {typeof value === 'boolean' ? (
                  <Icon
                    name={['common', value ? 'Check' : 'Close']}
                    style={{ color: value ? '#72bd43' : Colors.ACCENT }}
                  />
                ) : (
                  value
                )}
              </span>
            </div>
          );
        })}
      </div>
    );
  }
}
